/**
 * Related links sidebar UI component
 * @param  data 
 * @returns 
 * data : Array
 * relatedLinks : array
 * relatedlink.url : string
 * relatedlink.text : rawHtml string
 * 
 */ 

import React from "react"

function RelatedLinks(data) {
  if(data.data.relatedLinks !== null) {
    const relatedlinks = data.data.relatedLinks.map((relatedLink) => {
      return (
        <li className="link-items__link" key={relatedLink}>
          <a href={relatedLink.url}>{relatedLink.text}</a>
        </li>
      )
    }
    );
  return(
    <div className="relatedlinks dont-print">
      <div className="element--inner">
        <p className="heading related-links__heading">Related links</p>
        <nav role="navigation" aria-label="Related links navigation">
          <ul className="link-items">
            {relatedlinks}
          </ul>
        </nav>  
      </div>
    </div>

  )
} else {
  return null
}

}
export default RelatedLinks

